export default __webpack_public_path__ + "static/media/cr.5f3a5256.svg";